import { create } from "zustand";
interface LoadingState {
  loading: boolean;
  toggleLoading: (value: boolean) => void;
}
export const useLoadingStore = create<LoadingState>((set) => ({
  loading: false,
  toggleLoading: (value: boolean) => {
    if (value) set(() => ({ loading: true }));
    else setTimeout(() => set(() => ({ loading: false })), 500);
  },
}));
